import constantFactory from "@gaoding/constant-factory";

export const {
  UPLOAD_STATUS,
  UPLOAD_STATUS_LIST,
  UPLOAD_STATUS_MAP,
  UPLOAD_STATUS_ITEM_MAP,
} = constantFactory("UPLOAD_STATUS", [
  {
    key: "INIT",
    label: "初始化",
    value: "init",
  },
  {
    key: "UPLOADING",
    label: "上传中",
    value: "uploading",
  },
  {
    key: "UPLOADED",
    label: "上传完成",
    value: "uploaded",
  },
  {
    key: "ERROR",
    label: "上传失败",
    value: "error",
  },
]);
